import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PromptExecutionSettingsDto } from '../../api-service/clients';
import { ChatTabPanel } from './chat-tab-panel';
import { CitizenAssistantChatbox } from './citizen-assistant-chatbox';
import { FasitAssistantChatbox } from './fasit-assistant-chatbox';
import useChatCitizenContext from './hooks/use-chat-citizen-context';
import { useAiAssistantVisibility } from '../../hooks/ai-search/use-ai-assistant-visibility';

export interface IChatComponentProps {
  height?: string;
  tabIndex: number;
  onTabChange: (tabIndex: number) => void;
}

export function ChatComponent(props: IChatComponentProps) {
  const { height, tabIndex, onTabChange } = props;
  const [settings, setSettings] = useState<PromptExecutionSettingsDto>({});
  const { citizenId } = useChatCitizenContext();
  const { isFasitAssistantVisible, isCitizenAssistantVisible } = useAiAssistantVisibility();

  function handleSettingsChange(property: keyof PromptExecutionSettingsDto, value: any) {
    setSettings({ ...settings, [property]: value });
  }

  function handleTabChange(event: React.SyntheticEvent, newTabIndex: number) {
    onTabChange(newTabIndex);
  }

  useEffect(() => {
    if (citizenId) {
      onTabChange(1);
    }
  }, [citizenId]);

  const tabbedLayout = (
    <Box sx={{ position: 'relative', maxHeight: height ?? '100%', height: height ?? '100%', display: 'flex', flexDirection: 'column' }}>
      <Tabs value={tabIndex} onChange={handleTabChange}>
        <Tab label="Lexi" />
        {citizenId && <Tab label="Summa" />}
      </Tabs>
      <ChatTabPanel value={tabIndex} index={0}>
        <FasitAssistantChatbox onSettingsChange={handleSettingsChange} settings={settings} />
      </ChatTabPanel>
      <ChatTabPanel value={tabIndex} index={1}>
        <CitizenAssistantChatbox onSettingsChange={handleSettingsChange} settings={settings} citizenId={citizenId} />
      </ChatTabPanel>
    </Box>
  );

  if (isFasitAssistantVisible && isCitizenAssistantVisible) {
    return tabbedLayout;
  }
  if (isFasitAssistantVisible) {
    return <FasitAssistantChatbox onSettingsChange={handleSettingsChange} settings={settings} />;
  }
  if (isCitizenAssistantVisible) {
    return <CitizenAssistantChatbox onSettingsChange={handleSettingsChange} settings={settings} citizenId={citizenId} />;
  }
  return null;
}
